import React, { useState } from "react";
import { MdArrowBack } from "react-icons/md";
import CategoryCard from "./CategoryCard";
import { deleteArticle, setViewCount } from "../../api/helpCenterApi";
import { toast } from "react-toastify";
import LoadingSpinner from "../LoadingSpinner";
import logo_icon from "../../assets/cargotool-icon.png";

const HelpCenterSearchResults = ({
  results,
  setSelectedKey,
  setSearchClicked,
  setSelectedCard,
  setUpdateNeeded,
  setResults,
  selectedKey,
}) => {
  const [isDeleting, setIsDeleting] = useState(false);
  const handleBack = () => {
    setSearchClicked(false);
    setSelectedKey(null);
  };

  const handleDelete = async (articleId) => {
    setIsDeleting(true);
    try {
      await deleteArticle(articleId);
      setUpdateNeeded(true);
      toast.success("Article deleted successfully", {
        autoClose: 5000,
        containerId: "Modal",
      });
    } catch (error) {
      console.error("Failed to delete article:", error);
      toast.error("Failed to delete article.", {
        autoClose: 5000,
        containerId: "Modal",
      });
    }
    setIsDeleting(false);
  };

  const handleArticleClick = async (topic) => {
    try {
      setSelectedCard(topic);
      setSelectedKey(1);
      await setViewCount(topic.articleId);
      setUpdateNeeded(true);
    } catch (error) {
      console.error("Failed to set view count:", error);
    }
  };
  return (
    <>
      <div className="help-center-search-res-sub-container">
        <div className="help-center-sub-header">
          <div
            className="help-center-sub-logo-header"
            style={{
              position: "absolute",
              left: 20,
              top: 20,
              cursor: "pointer",
              zIndex: "1000",
            }}
          >
            <img
              src={logo_icon}
              alt="logo-icon"
              className="help-center-logo-icon"
            />
            <div className="help-center-logo">HELP CENTER</div>
          </div>
          <MdArrowBack
            color="black"
            size={30}
            className="help-back-icon"
            onClick={handleBack}
            style={{
              position: "absolute",
              right: 60,
              top: 20,
              cursor: "pointer",
              zIndex: "1000",
            }}
          />
        </div>

        <div className="help-center-sub-deleted-title">
          <h3 className="sub-text-title">Search Results</h3>
          <div>
            {results.length ? (
              <h4 className="sub-text-deleted-des">
                Found {results.length} topic{results.length > 1 ? "s" : ""}
              </h4>
            ) : (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  marginTop: "10px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "10px",
                  }}
                >
                  <svg
                    width="120"
                    height="120"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#999"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle cx="11" cy="11" r="8" />
                    <line x1="21" y1="21" x2="16.65" y2="16.65" />
                  </svg>
                  <h2 style={{ color: "black" }}>
                    No help Center topics matched your search.
                  </h2>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <div
        style={{
          margin: "0 auto",
          padding: "0 20px 40px 20px",
          cursor: "pointer",
          height: "70vh",
          overflowY: "auto",
        }}
      >
        {results?.map((topic) => (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <CategoryCard
              icon={topic.icon}
              title={topic.title}
              description={topic.slug}
              views={topic.viewCount}
              recover={false}
              isVideo={topic.isVideo}
              docCount={topic.docCount}
              onClick={() => handleArticleClick(topic)}
              onDeleteClick={() => {
                setResults(
                  results?.filter((item) => item.articleId !== topic.articleId)
                );
                handleDelete(topic.articleId);
              }}
            />
          </div>
        ))}
      </div>
      {/* {isDeleting && (
        <div className="blur-overlay">
          <LoadingSpinner message={`Deleting ...`} />
        </div>
      )} */}
    </>
  );
};

export default HelpCenterSearchResults;

const styles = `
  .blur-overlay {
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background: rgba(0, 0, 0, 0.5); /* Semi-transparent background */
    z-index: 9999; /* Ensure it's on top of everything */
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .blurred {
    filter: blur(5px); /* Blur effect on content */
    pointer-events: none; /* Prevent interaction with blurred content */
  }
`;

document.head.insertAdjacentHTML("beforeend", `<style>${styles}</style>`);
